import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { InputItem } from '../../types';

export const isTransItem = (
	item: InputItem
): item is Percomatic.Serialized.TransItem => {
	return (item as Percomatic.Serialized.TransItem).isSent !== undefined;
};
